import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const init = (isRM) => {
  const ourDataHero = document.querySelector('.our-data');
  if (!ourDataHero) return;

  const screenW = innerWidth;
  const badgeW = gsap.getProperty('.our-data__badge', 'width');
  const heroCopy = ourDataHero.querySelector('.our-data__left-column');

  gsap.set(heroCopy, { opacity: 1 });
  if (!isRM) {
    gsap.set('.our-data__badge', {
      xPercent: screenW > 1080 ? -60 : 0,
      yPercent: screenW > 1080 ? 0 : -120,
      scale: (screenW + 100) / badgeW
    });

    gsap
      .timeline({ delay: 1.25 })
      .from(heroCopy.children, { y: 20, autoAlpha: 0, stagger: 0.125 })
      .fromTo(
        '.our-data__image',
        { opacity: 0, scale: 0.2, y: 30 },
        { opacity: 1, scale: 1, y: 0 },
        0.25
      )
      .from('.our-data__badge', { autoAlpha: 0, duration: 1, ease: 'sine' }, 0)
      .to('.our-data__badge', {
        keyframes: {
          ease: 'none',
          xPercent: [
            screenW > 1080 ? -60 : 0,
            120,
            -100,
            screenW > 1080 ? -60 : 0
          ]
        },
        ease: 'sine.in',
        duration: 4
      })
      .to(
        '.our-data__badge',
        {
          xPercent: 50,
          yPercent: -50,
          x: 0,
          y: 0,
          scale: 1,
          duration: 0.75,
          ease: 'circ.in'
        }
        // 2
      );

    const heroBadgeSpin = gsap.to('.our-data__badge', {
      repeat: -1,
      rotate: 360,
      ease: 'none',
      duration: 40
    });

    ScrollTrigger.create({
      trigger: ourDataHero,
      start: 'top bottom',
      end: 'bottom top',
      animation: heroBadgeSpin,
      toggleActions: 'play pause resume pause'
    });
  } else {
    gsap.set([heroCopy.children, '.our-data__badge', '.our-data__image'], {
      y: 0,
      autoAlpha: 1
    });
    gsap.set('.our-data__badge', {
      x: 0,
      y: 0,
      xPercent: 50,
      yPercent: -50
    });
  }
};

export { init };
